import { useContext, useEffect, useRef } from 'react';
import { DatafeedContext, SetDatafeedAction } from '.';

const useDatafeedMessage: SetDatafeedAction = (channel, key, callbackFn) => {
  const { setAction } = useContext(DatafeedContext);
  const actionSet = useRef(false);

  useEffect(() => {
    if (actionSet.current) return;

    actionSet.current = true;
    setAction(channel, key, callbackFn);
  }, []);
};

export default useDatafeedMessage;
